module.exports = __webpack_public_path__ + "static/img/9.7ad98ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/9.png
// module id = KEgh
// module chunks = 0